module.exports = __webpack_public_path__ + "static/doctor-heart-54600ef389492bb7a5aa55d37bfc7fe5.png";